$.fn.Characters = function() {
	/* Instance */
	let self = this
	if (self.data('instance')) {
		return self;
	}
	self.data('instance', self)
	self.state = $('<span class="characters"></span>')
  self.maxlength = parseInt(self.attr('maxlength'), 10)

	self.update = function() {
    let remaining = self.maxlength - self.val().length;
    if (remaining === 0) {
      self.state.html('Limite de caractères atteinte')
    } else if (remaining === 1) {
      self.state.html('<strong>' + remaining + '</strong> caractère restant')
    } else {
      self.state.html('<strong>' + remaining + '</strong> caractères restants')
    }
	}

	return function() {
    if (!self.maxlength) {
      self.maxlength = 350
    }
		self.on('keyup keydown keypress change focus blur', self.update)
		self.update()
		self.after(self.state)
		return self
	}()
}
